var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagMalawi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 15.9999C0 17.957 0.352063 19.8318 0.995188 21.5651L16 22.2608L31.0048 21.5651C31.648 19.8318 32 17.957 32 15.9999C32 14.0428 31.648 12.168 31.0048 10.4347L16 9.73901L0.995188 10.4346C0.352063 12.168 0 14.0428 0 15.9999H0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0C9.12055 0 3.25587 4.342 0.995178 10.4348H31.0049C28.7441 4.342 22.8794 0 16 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0048 21.5652H0.995178C3.25587 27.6579 9.12055 32 16 32C22.8794 32 28.7441 27.6579 31.0048 21.5652Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7822 7.65228L18.8282 6.73315L19.8688 4.84071L17.7469 5.24665L17.478 3.10303L16 4.67959L14.5221 3.10303L14.2531 5.24665L12.1313 4.84071L13.1719 6.73315L11.2178 7.65228H20.7822Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15930"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagMalawi);
export default __webpack_public_path__ + "static/media/flag_malawi.9db816d7a2d3971f43d23d8ddc831c31.svg";
export { ForwardRef as ReactComponent };